import { API, Lang, LangObject, Status, Team, TeamAPI } from "@brg/api";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import {
  BaseSyntheticEvent,
  FC,
  SyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
  type MouseEvent,
} from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import urlApi from "shared/actions/urlApi";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import TextInput from "../TeamEditNew/components/fields/TextInput";
import PhoneInput from "../TeamEditNew/components/fields/PhoneInput";
import DropdownField from "shared/pages/CompetitionApplicationForm/components/fields/DropdownField";
import { CoreContainer, LayoutConst } from "core";
import styled, { useTheme } from "styled-components";
import { CommonInput, Dropdown, FlexBox, INPUT_TYPES, useBreakpoint, ButtonVariant, BrgButton, MEDIA } from "@brg/ui";
import { Divider } from "shared/pages/CompetitionApplicationForm/components/styles";
import { SendButton } from "shared/modals/sendProjects/styles";
import { ProjectEditPageGridLabel } from "shared/components/ProjectEditPageGrid";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import { TFile } from "@brg/api";
import { useSelector } from "react-redux";
import { HsePolicies } from "shared/constants/HsePolicies";
import { DropdownListItemTeamEdit, SettingsDotsWrapper } from "shared/pages/exploreHseContextsNew/styles";
import { SettingsDotsIcon } from "shared/icons/SettingsDotsIcon";
import { FormCheckMarkPosition, DEFAULT_CHECK_MARK_POSITION, DEFAULT_CHECK_MARK_STATE } from "../const/FormCheckMarkPosition";
import { canEditTeamForm } from "../helpers/canEditTeamForm";
const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`
export const Wrapper = styled.div`
  max-width: 904px;
  margin: 50px auto 0;

  input:not(:disabled, .protect-input),
  textarea:not(:disabled) {
    color: ${({ theme }) => theme.commonInput?.color ?? (theme.isDarkText ? '#151514' : '#FEFEFE')} !important;
  }

  .brg-input__multi-value__label,
  .brg-input__single-value {
    color: ${({ theme }) => theme.commonInput?.color ?? (theme.isDarkText ? '#151514' : '#FEFEFE')} !important;
  }

  .brg-input__value-container {
      white-space: nowrap;
      overflow: hidden;
      max-width: 100%;
      min-width: 0;
      position: relative;
  }

  .brg-input__placeholder {
      overflow: hidden;
      text-overflow: ellipsis;
      left: 16px;
      right: 20px;
  }

  @media ${MEDIA.LAPTOP} {
    max-width: 712px;
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
      margin: 0 auto;

      .brg-input__control {
          height: 40px !important;
      }

      .brg-input__value-container {
          height: 40px !important;
      }

      .brg-input__indicator {
          padding-top: 8px;
      }
  }
`;

const TeamFormAdminLinksWrap = styled.div`
  max-width: 904px;
  margin: 0 auto 0;
  padding: 0 48px 0 16px;
  position: relative;
  @media ${MEDIA.LAPTOP} {
    max-width: 712px;
  }
`;

export const TitleImagesContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  border-radius: 8px;
  overflow: hidden;
`;

export const MainTitle = styled.div<{ isMobile?: boolean }>`
  font-family: Inter;
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px;
  letter-spacing: -0.6px;
  // max-width: 440px;
  color: ${(p) => p.theme.mainSearchBar.text.color};

  @media ${MEDIA.LAPTOP} {
    font-size: 30px;
    line-height: 40px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;
export const СompletedTitle = styled.div`
  font-family: Inter;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.6px;
  color: #909090;
  margin-bottom: 16px;
`;
export const MainDescription = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.3px;
  color: ${(p) => p.theme.mainSearchBar.text.color_desc};
  white-space: pre-line;

  @media ${MEDIA.LAPTOP} {
    font-size: 13px;
  }
`;
export const AnswersCount = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.2px;
  margin-top: 24px;
  color: #909090;
  span{
   font-weight: 600;
   color: #212529;
  }
`;
const FORM_NAME = 'registrationForm';
interface FormData {
  registrationRequestLimit: number;
  isRegistrationRequestLimitVisible: boolean;
  creatorAccountId: string | null;
  formId: string;
  teamId: string;
  techName: string;
  header: string;
  description: string;
  titleImages?: TFile[];
  integration: any;
  textOnComplete: string;
  textSubmitButton: string;
  pndFields: any[];
  formFields: any[];
  crmName: string;
  created: string;
  updated: string;
  formAddress: string;
  isRegisteredUsersOnly: boolean;
  comment: string | null;
  needCapcha: boolean;
  unisenderListNumber: number | string | null;
  finalCourseId: string | null;
  formEvent: any | null;
  formTags: any | null;
  shouldSendEmailNotification: boolean;
  emailNotificationSubject: string;
  emailNotificationText: string;
}

type PpdCheckMark = { index: number; name: string };

interface EventRegistrationComponentProps extends InjectedFormProps {
  isPpdAccepted?: boolean;
  answersCount?: number | null;
  isSubmiting?: boolean;
  setIsPpdAccepted?: any;
  skipFetch?: boolean;
  statusTags?: Status[];
  isModal?: boolean;
  onCancel?: () => void;
  cancelText?: string;
  formIdOverride?: string;
  data?: Record<string, any>;
}

const EventRegistrationComponent: FC<EventRegistrationComponentProps> = ({
  submitting,
  invalid,
  handleSubmit,
  pristine,
  isPpdAccepted,
  setIsPpdAccepted,
  isSubmiting,
  answersCount,
  skipFetch,
  isModal,
  statusTags,
  onCancel,
  cancelText,
  formIdOverride,
  data: formDataFromProps,
}) => {
  const { formId: routeFormId } = useParams<{ formId: string }>();
  const { i18n } = useTranslation();
  const [formData, setFormData] = useState<any>(skipFetch ? (formDataFromProps || {}) : {});
  const [selectedFormId, setSelectedFormId] = useState<string | null>('');
  const [loading, setLoading] = useState(!skipFetch);
  const [error, setError] = useState<string | null>(null);
  const [ppdAcceptedStates, setPpdAcceptedStates] = useState<boolean[]>([]);
  const {t, i18n: { language }} = useTranslation();

  const formId = selectedFormId || formIdOverride || routeFormId;
  
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  const parts = useMemo(() => {
    if (!formData?.pndFields?.[0]?.value) {
      return [];
    }
    return Lang(formData?.pndFields?.[0]?.value, i18n.language).split(urlRegex);
  }, [formData?.pndFields?.[0]?.value, i18n.language]);

  const formValues = useSelector((state: any) => state?.form)

  const isRuPhoneCode = useMemo(() => {
    const values = formValues?.[FORM_NAME]?.values

    const field = Object.entries(values).reduce((acc, [key, value]) => {
      const sliceKey = key.slice(0, -1)

      if (sliceKey?.includes('3')) {
        acc[sliceKey] = value;
      }
    
      return acc;
    }, {} as Record<string, any>);

    return Object.values(field)?.[0]?.startsWith('+7')
  } , [formValues])

  const history = useHistory();
  const theme = useTheme();
  const isMdUp = useBreakpoint(LayoutConst.screen.md);
  const profile = useProfile();
  const [isToolbarHovered, setIsToolbarHovered] = useState(false);
  const [teamEntity, setTeamEntity] = useState<Team<'Global'> | null>(null);

  const isSuperModer = useMemo(() => profile && bProfile.isModer(profile), [profile]);

  const isTeamOwner = useMemo(
    () => profile && teamEntity && teamEntity.ownersIDs?.includes(profile.accountId),
    [profile, teamEntity],
  );

  

  // const canEditTeamFeedbackForm = useMemo(
  //   () => isSuperModer || isTeamOwner,
  //   [isSuperModer, isTeamOwner],
  // );

  const canEditTeamFeedbackForm = useMemo(
    () => profile && teamEntity && canEditTeamForm(profile, teamEntity),
    [profile, teamEntity],
  );

  const isEmployee = useMemo(
    () => profile && (bProfile.isEmployee(profile) || profile?.globalTypes?.includes('Cooperator')),
    [profile],
  );

  const isTeamMember = useMemo(() => {
    if (!profile?.accountId || !teamEntity) {
      return false;
    }
    return Boolean(teamEntity.membersIDs?.includes(profile.accountId));
  }, [profile?.accountId, teamEntity]);

  const canShowTeamFormMenu = useMemo(
    () => !isModal && (isEmployee || isTeamMember || isSuperModer || canEditTeamFeedbackForm),
    [isModal, isTeamMember, isEmployee, isSuperModer, canEditTeamFeedbackForm],
  );

  const teamPublicPath = useMemo(() => {
    return `/teams/${teamEntity?.teamId}`;
  }, [teamEntity?.contextName, teamEntity?.teamId, formData?.teamId]);

  const canShowOrganizationMenuItem = useMemo(
    () => Boolean(teamPublicPath) && (isEmployee || isSuperModer || isTeamOwner),
    [teamPublicPath, isEmployee, isSuperModer, isTeamOwner],
  );

  const teamOrganizationName = useMemo(
    () => (teamEntity ? Lang(teamEntity.name, language) : ""),
    [teamEntity, language],
  );

  const handleOrganizationClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      history.push(teamPublicPath);
    },
    [history, teamPublicPath],
  );

  const handleEditFormClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (!formData?.teamId) {
        return;
      }
      history.push(`/team-edit/${formData.teamId}?formId=${formId}`);
    },
    [formData?.teamId, formId, history],
  );

  useEffect(() => {
    const teamId = formData?.teamId;
    if (!teamId) {
      setTeamEntity(null);
      return;
    }

    let cancelled = false;

    TeamAPI.Get({ idTeam: teamId })
      .then((r) => r.json() as Promise<Team<'Global'>>)
      .then((value) => {
        if (!cancelled && value?.teamId) {
          setTeamEntity(value);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setTeamEntity(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [formData?.teamId]);

   useEffect(() => {
    if (skipFetch) {
      if (formDataFromProps) {
        setFormData(formDataFromProps);
      }
      setLoading(false);
      return;
    }

    if (!formId) {
      return;
    }

    let cancelled = false;

    const fetchForm = async () => {
      try {
        setLoading(true);
        const response = await urlApi().getForm(formId);
        const form = await response.json();

        if (cancelled) {
          return;
        }

        setFormData(form);
      } catch (err) {
        if (!cancelled) {
          setError('Failed to fetch form data');
          console.error('Error fetching form:', err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchForm();

    return () => {
      cancelled = true;
    };
  }, [formId, skipFetch, formDataFromProps?.formId]);
  const translatedForm: FormData = API.toLang(formData, i18n.language)

  const visiblePpdCheckMarks = useMemo<PpdCheckMark[]>(() => {
    if (!Array.isArray(formData?.ppdWithCheckMark)) {
      return [];
    }

    return formData.ppdWithCheckMark
      .map((langGroup: any[], index: number) => ({
        index,
        name: langGroup?.find((item: any) => item.lang === language)?.name,
      }))
      .filter((item: { name?: string }) => !!item.name);
  }, [formData?.ppdWithCheckMark, language]);

  const isCheckMarkOnLeft =
    (formData?.ppdCheckMarkPosition ?? DEFAULT_CHECK_MARK_POSITION) === FormCheckMarkPosition.Left;

  useEffect(() => {
    if (!Array.isArray(formData?.ppdWithCheckMark)) {
      return;
    }

    const defaultState = formData?.ppdCheckMarkDefaultState ?? DEFAULT_CHECK_MARK_STATE;
    setPpdAcceptedStates(new Array(formData.ppdWithCheckMark.length).fill(defaultState));
  }, [formData?.ppdWithCheckMark, formData?.ppdCheckMarkDefaultState]);

  useEffect(() => {
    if (visiblePpdCheckMarks.length > 0) {
      const allAccepted = visiblePpdCheckMarks.every(({ index }) => ppdAcceptedStates[index]);
      setIsPpdAccepted(allAccepted);
    }
  }, [visiblePpdCheckMarks, ppdAcceptedStates, setIsPpdAccepted]);
  
  const handlePpdChange = (index: number, checked: boolean) => {
    setPpdAcceptedStates(prev => {
      const newStates = [...prev];
      newStates[index] = checked;
      return newStates;
    });
  };
  
  const ppdWithCheckMarks = visiblePpdCheckMarks.map(({ index, name }) => {
    const ppdParts = name.split(urlRegex);

    const ppdText = (
      <ProjectEditPageGridLabel fullWidth heightAuto>
        <div style={{ whiteSpace: 'pre-wrap', width: '100%', wordBreak: 'break-word' }}>
          {ppdParts.map((part, i) =>
            urlRegex.test(part) ? (
              <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                {part}
              </a>
            ) : (
              part
            )
          )}
        </div>
      </ProjectEditPageGridLabel>
    );

    const ppdCheckMark = (
      <FlexBox direction="row" directionMobile="row">
        <CommonInput
          type={INPUT_TYPES.checkbox} 
          title={''}
          checked={ppdAcceptedStates[index] || false}
          onChange={(ev: any) => handlePpdChange(index, ev.target.checked)}
        />
      </FlexBox>
    );

    return (
      <FlexBox key={index} align="flex-start" gx={isCheckMarkOnLeft ? 8 : undefined}>
        {isCheckMarkOnLeft ? ppdCheckMark : ppdText}
        {isCheckMarkOnLeft ? ppdText : ppdCheckMark}
      </FlexBox>
    );
  });
   
  const getTranslatedVariants = (variants: any[]) => {
    if (!variants || !Array.isArray(variants)) return [];

    return variants?.reduce((acc, val) => {
      const variant = val.find((v: any) => v.lang === i18n.language) || val[0];
      const isPhone = ['телефон', 'phone']?.includes(variant?.name?.toLowerCase())
      if (variant?.name === '') {
        return acc
      }
      if (!isRuPhoneCode && isPhone) {
        return acc
      }

      return [
        ...acc,
        {
          value: variant.name,
          label: variant.name
        }
      ]
    }, [])
  };

  const renderField = (field: any, index: number) => {
    const commonProps = {
      key: index,
      name: `field_${field.type}_${index}`,
      label: field.header,
      placeholder: field.placeholder,
      required: field.isRequired,
    };

    switch (field.type) {
      case 0: // Текстовое поле
        return (
           <Field
            {...commonProps}
            label={field.header || 'Текст'}
            component={TextInput}
          />
        );
      case 1: // Комментарий
        return (
           <Field
            {...commonProps}
            label={field.header || 'Комментарий'}
            component={TextInput}
            multiline={true}
          />
        );
      case 2: // Почта
        return (
           <Field
            {...commonProps}
            label={field.header || 'Почта'}
            component={TextInput}
          />
        );
      case 3: // Телефон
        return (
           <Field
            {...commonProps}
            label={field.header || 'Телефон'}
            component={PhoneInput}
          />
        );
      case 4: // Выпадающий список (одиночный выбор)
        return (
          <Field
            {...commonProps}
            label={field.header || 'Выбор'}
            component={DropdownField}
            options={getTranslatedVariants(field.inlineVariants)}
          />
        );
      case 6: // Текстовое поле (ФИО)
        return (
          <Field
            {...commonProps}
            label={field.header || 'Имя'}
            component={TextInput}
          />
        );
      case 7: // Текстовое поле (Фамилия)
        return (
          <Field
            {...commonProps}
             label={field.header || 'Фамилия'}
            component={TextInput}
          />
        );
      
      case 8: // Множественный выбор (чекбоксы)
        return (
          <Field
            {...commonProps}
            component={DropdownField}
            label={field.header || 'Множественный выбор'}
            options={getTranslatedVariants(field.inlineVariants)}
            isMulti={true}
          />
        );
      case 9: // Telegram
        return (
          <Field
            {...commonProps}
            label={field.header || 'Telegram'}
            component={TextInput}
          />
        );
      case 10: // Доп. почта
        return (
           <Field
            {...commonProps}
            label={field.header || 'Почта'}
            component={TextInput}
          />
        );
      default:
        return null;
    }
  };

  const statusTagsField = useMemo(() => {
    if (!statusTags || statusTags?.length < 2) {
      return null;
    }
    return (
      <CommonInput 
        type={INPUT_TYPES.dropdown}
        label="Профиль"
        required={true}
        value={(statusTags?.find((status) => status?.formId === formId)?.name as unknown as string) || ''} 
        options={statusTags.map((status) => ({
          value: status.formId,
          label: Lang(status.name, i18n.language),
        }))}
        onChange={({ value }: { value: string }) => {
          setSelectedFormId(value);
        }}
      />
    )
  }, [statusTags, formId, i18n.language])

const handleCloseClick = () => {
  if (window.history.length > 1 && document.referrer !== '') {
    window.history.back();
  } else {
    window.location.href = '/';
  }
};
  

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!translatedForm) return null;
  
  if (!answersCount && translatedForm?.registrationRequestLimit) {
    return (
      <CoreContainer>
      <Wrapper>
        <MainTitle>{translatedForm.header}</MainTitle>
        <MainDescription>{translatedForm.description}</MainDescription>
        <FlexBox direction="column" offsetTop={32} gy={16} justify="center" align="center">
        <СompletedTitle>{t('form_page.deadline')}</СompletedTitle>
        <SendButton onClick={handleCloseClick} >
              {t('form_page.close')}
        </SendButton>
        </FlexBox>
      </Wrapper>
    </CoreContainer>
    )
  };

  const formContent = (
    <Wrapper style={isModal ? { margin: 0, maxWidth: '100%' } : undefined}>
      {translatedForm?.titleImages && Array.isArray(translatedForm.titleImages) && translatedForm.titleImages.length > 0 && (
        <TitleImagesContainer>
          <ResizedImageEnhanced
            files={translatedForm.titleImages}
            showDefaultPlaceholder={false}
            showEmptyPlaceholder={false}
          />
        </TitleImagesContainer>
      )}
      <TitleWrapper>
        <MainTitle>{translatedForm.header}</MainTitle>
        {canShowTeamFormMenu && (isToolbarHovered || isMdUp) && (
          <SettingsDotsWrapper>
            <Dropdown
              offsetY={8}
              offsetX={0}
              hideArrow
              orientation="right"
              target={<SettingsDotsIcon />}
            >
              {canShowOrganizationMenuItem && (
                <DropdownListItemTeamEdit
                  theming={theme.navigationBar.login}
                  onClick={handleOrganizationClick}
                >
                  {t("form_page.organization_with_name", { name: teamOrganizationName })}
                </DropdownListItemTeamEdit>
              )}
              {canEditTeamFeedbackForm && (
                <DropdownListItemTeamEdit
                  theming={theme.navigationBar.login}
                  onClick={handleEditFormClick}
                >
                  {t("form_page.edit_form")}
                </DropdownListItemTeamEdit>
              )}
            </Dropdown>
          </SettingsDotsWrapper>
        )}
      </TitleWrapper>
      <MainDescription>{translatedForm.description}</MainDescription>
      {translatedForm?.isRegistrationRequestLimitVisible && <AnswersCount>{t('form_page.count_text')} <span>{answersCount}</span></AnswersCount>}
      <FlexBox direction="column" gy={16} gyMobile={16} offsetTop={48}>
        {statusTagsField}
        {translatedForm.formFields?.map((field: any, index: number) =>
          renderField(field, index)
        )}

        <Divider/>
        <FlexBox gx={24} directionMobile={'column'} gyMobile={16} gxMobile={'0px'} align="center">
          {onCancel && (
            <BrgButton variant={ButtonVariant.Hollow} onClick={onCancel}>
              {cancelText || t('close')}
            </BrgButton>
          )}
          <SendButton $mobileFullWidth onClick={handleSubmit} disabled={!isPpdAccepted || pristine || invalid || submitting || isSubmiting}>
            {translatedForm.textSubmitButton}
          </SendButton>
          {parts?.length > 0 && (
            <div style={{fontSize: '13px', color: '#909090'}}> {parts.map((part, i) =>
              urlRegex.test(part) ? (
                <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                  {part}
                </a>
              ) : (
                part
              )
            )}
          </div>
          )}
        </FlexBox>
      </FlexBox>
      <FlexBox direction="column" gy={8} offsetTop={16}>
          {ppdWithCheckMarks}
      </FlexBox>
    </Wrapper>
  );

  if (isModal) {
    return formContent;
  }

  return (
    <>
      <CoreContainer>
          <TeamFormAdminLinksWrap
            onMouseEnter={() => setIsToolbarHovered(true)}
            onMouseLeave={() => setIsToolbarHovered(false)}
          >
            <FlexBox align="center" style={{ position: "relative", minHeight: 28 }}>
            {formContent}
          </FlexBox>
      </TeamFormAdminLinksWrap>
      </CoreContainer>
    </>
  );
}
const validate = (values: any, props: any) => {
  const {data} = props
  const errors: any = {};
   
 data.formFields.forEach((field: any, index: number) => {
    const fieldName = `field_${field.type}_${index}`;
    
    if (field.isRequired && !values[fieldName]) {
      errors[fieldName] = 'Обязательное поле';
    }

    // Дополнительная валидация для email
    if (field.type === 2 && values[fieldName] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values[fieldName])) {
      errors[fieldName] = 'Некорректный email';
    }

    // Валидация для телефона
    if (field.type === 3 && values[fieldName]) {
      const phoneValue = values[fieldName];
      const digitsOnly = phoneValue.replace(/\D/g, '');
      if (digitsOnly.length < 11) {
        errors[fieldName] = 'Некорректный номер телефона';
      }
    }
  });

  
  return errors;
};

export const EventRegistrationForm = reduxForm({
  form: FORM_NAME,
  validate: validate,
  
})(EventRegistrationComponent);
import { API, Lang, LangObject, Status, Team, TeamAPI } from "@brg/api";
import { bProfile, ProfileRole, useProfile } from "@brg/auth";
import {
  BaseSyntheticEvent,
  FC,
  SyntheticEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
  type MouseEvent,
} from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import urlApi from "shared/actions/urlApi";
import { Field, InjectedFormProps, reduxForm } from "redux-form";
import TextInput from "../TeamEditNew/components/fields/TextInput";
import PhoneInput from "../TeamEditNew/components/fields/PhoneInput";
import DropdownField from "shared/pages/CompetitionApplicationForm/components/fields/DropdownField";
import { CoreContainer, LayoutConst } from "core";
import styled, { useTheme } from "styled-components";
import { CommonInput, Dropdown, FlexBox, INPUT_TYPES, useBreakpoint, ButtonVariant, BrgButton, MEDIA } from "@brg/ui";
import { Divider } from "shared/pages/CompetitionApplicationForm/components/styles";
import { SendButton } from "shared/modals/sendProjects/styles";
import { ProjectEditPageGridLabel } from "shared/components/ProjectEditPageGrid";
import { ApprovedIcon } from "shared/icons/ApprovedIcon";
import ResizedImageEnhanced from "shared/components/ResizedImageEnhanced";
import { TFile } from "@brg/api";
import { useSelector } from "react-redux";
import { HsePolicies } from "shared/constants/HsePolicies";
import { DropdownListItemTeamEdit, SettingsDotsWrapper } from "shared/pages/exploreHseContextsNew/styles";
import { SettingsDotsIcon } from "shared/icons/SettingsDotsIcon";
import { FormCheckMarkPosition, DEFAULT_CHECK_MARK_POSITION, DEFAULT_CHECK_MARK_STATE } from "../const/FormCheckMarkPosition";
import { canEditTeamForm } from "../helpers/canEditTeamForm";
const TitleWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`
export const Wrapper = styled.div`
  max-width: 904px;
  margin: 50px auto 0;

  input:not(:disabled, .protect-input),
  textarea:not(:disabled) {
    color: ${({ theme }) => theme.commonInput?.color ?? (theme.isDarkText ? '#151514' : '#FEFEFE')} !important;
  }

  .brg-input__multi-value__label,
  .brg-input__single-value {
    color: ${({ theme }) => theme.commonInput?.color ?? (theme.isDarkText ? '#151514' : '#FEFEFE')} !important;
  }

  .brg-input__value-container {
      white-space: nowrap;
      overflow: hidden;
      max-width: 100%;
      min-width: 0;
      position: relative;
  }

  .brg-input__placeholder {
      overflow: hidden;
      text-overflow: ellipsis;
      left: 16px;
      right: 20px;
  }

  @media ${MEDIA.LAPTOP} {
    max-width: 712px;
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
      margin: 0 auto;

      .brg-input__control {
          height: 40px !important;
      }

      .brg-input__value-container {
          height: 40px !important;
      }

      .brg-input__indicator {
          padding-top: 8px;
      }
  }
`;

const TeamFormAdminLinksWrap = styled.div`
  max-width: 904px;
  margin: 0 auto 0;
  padding: 0 48px 0 16px;
  position: relative;
  @media ${MEDIA.LAPTOP} {
    max-width: 712px;
  }
`;

export const TitleImagesContainer = styled.div`
  width: 100%;
  margin-bottom: 32px;
  border-radius: 8px;
  overflow: hidden;
`;

export const MainTitle = styled.div<{ isMobile?: boolean }>`
  font-family: Inter;
  font-size: 43px;
  font-style: normal;
  font-weight: 600;
  line-height: 51px;
  letter-spacing: -0.6px;
  // max-width: 440px;
  color: ${(p) => p.theme.mainSearchBar.text.color};

  @media ${MEDIA.LAPTOP} {
    font-size: 30px;
    line-height: 40px;
  }

  @media ${MEDIA.MOBILE} {
    font-size: 20px;
    line-height: 25px;
  }
`;
export const СompletedTitle = styled.div`
  font-family: Inter;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.6px;
  color: #909090;
  margin-bottom: 16px;
`;
export const MainDescription = styled.div`
  font-family: Inter;
  font-size: 15px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.3px;
  color: ${(p) => p.theme.mainSearchBar.text.color_desc};
  white-space: pre-line;

  @media ${MEDIA.LAPTOP} {
    font-size: 13px;
  }
`;
export const AnswersCount = styled.div`
  font-family: Inter;
  font-size: 17px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: -0.2px;
  margin-top: 24px;
  color: #909090;
  span{
   font-weight: 600;
   color: #212529;
  }
`;
const FORM_NAME = 'registrationForm';
interface FormData {
  registrationRequestLimit: number;
  isRegistrationRequestLimitVisible: boolean;
  creatorAccountId: string | null;
  formId: string;
  teamId: string;
  techName: string;
  header: string;
  description: string;
  titleImages?: TFile[];
  integration: any;
  textOnComplete: string;
  textSubmitButton: string;
  pndFields: any[];
  formFields: any[];
  crmName: string;
  created: string;
  updated: string;
  formAddress: string;
  isRegisteredUsersOnly: boolean;
  comment: string | null;
  needCapcha: boolean;
  unisenderListNumber: number | string | null;
  finalCourseId: string | null;
  formEvent: any | null;
  formTags: any | null;
  shouldSendEmailNotification: boolean;
  emailNotificationSubject: string;
  emailNotificationText: string;
}

type PpdCheckMark = { index: number; name: string };

interface EventRegistrationComponentProps extends InjectedFormProps {
  isPpdAccepted?: boolean;
  answersCount?: number | null;
  isSubmiting?: boolean;
  setIsPpdAccepted?: any;
  skipFetch?: boolean;
  statusTags?: Status[];
  isModal?: boolean;
  onCancel?: () => void;
  cancelText?: string;
  formIdOverride?: string;
  data?: Record<string, any>;
}

const EventRegistrationComponent: FC<EventRegistrationComponentProps> = ({
  submitting,
  invalid,
  handleSubmit,
  pristine,
  isPpdAccepted,
  setIsPpdAccepted,
  isSubmiting,
  answersCount,
  skipFetch,
  isModal,
  statusTags,
  onCancel,
  cancelText,
  formIdOverride,
  data: formDataFromProps,
}) => {
  const { formId: routeFormId } = useParams<{ formId: string }>();
  const { i18n } = useTranslation();
  const [formData, setFormData] = useState<any>(skipFetch ? (formDataFromProps || {}) : {});
  const [selectedFormId, setSelectedFormId] = useState<string | null>('');
  const [loading, setLoading] = useState(!skipFetch);
  const [error, setError] = useState<string | null>(null);
  const [ppdAcceptedStates, setPpdAcceptedStates] = useState<boolean[]>([]);
  const {t, i18n: { language }} = useTranslation();

  const formId = selectedFormId || formIdOverride || routeFormId;
  
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  const parts = useMemo(() => {
    if (!formData?.pndFields?.[0]?.value) {
      return [];
    }
    return Lang(formData?.pndFields?.[0]?.value, i18n.language).split(urlRegex);
  }, [formData?.pndFields?.[0]?.value, i18n.language]);

  const formValues = useSelector((state: any) => state?.form)

  const isRuPhoneCode = useMemo(() => {
    const values = formValues?.[FORM_NAME]?.values

    const field = Object.entries(values).reduce((acc, [key, value]) => {
      const sliceKey = key.slice(0, -1)

      if (sliceKey?.includes('3')) {
        acc[sliceKey] = value;
      }
    
      return acc;
    }, {} as Record<string, any>);

    return Object.values(field)?.[0]?.startsWith('+7')
  } , [formValues])

  const history = useHistory();
  const theme = useTheme();
  const isMdUp = useBreakpoint(LayoutConst.screen.md);
  const profile = useProfile();
  const [isToolbarHovered, setIsToolbarHovered] = useState(false);
  const [teamEntity, setTeamEntity] = useState<Team<'Global'> | null>(null);

  const isSuperModer = useMemo(() => profile && bProfile.isModer(profile), [profile]);

  const isTeamOwner = useMemo(
    () => profile && teamEntity && teamEntity.ownersIDs?.includes(profile.accountId),
    [profile, teamEntity],
  );

  

  // const canEditTeamFeedbackForm = useMemo(
  //   () => isSuperModer || isTeamOwner,
  //   [isSuperModer, isTeamOwner],
  // );

  const canEditTeamFeedbackForm = useMemo(
    () => profile && teamEntity && canEditTeamForm(profile, teamEntity),
    [profile, teamEntity],
  );

  const isEmployee = useMemo(
    () => profile && (bProfile.isEmployee(profile) || profile?.globalTypes?.includes('Cooperator')),
    [profile],
  );

  const isTeamMember = useMemo(() => {
    if (!profile?.accountId || !teamEntity) {
      return false;
    }
    return Boolean(teamEntity.membersIDs?.includes(profile.accountId));
  }, [profile?.accountId, teamEntity]);

  const canShowTeamFormMenu = useMemo(
    () => !isModal && (isEmployee || isTeamMember || isSuperModer || canEditTeamFeedbackForm),
    [isModal, isTeamMember, isEmployee, isSuperModer, canEditTeamFeedbackForm],
  );

  const teamPublicPath = useMemo(() => {
    return `/teams/${teamEntity?.teamId}`;
  }, [teamEntity?.contextName, teamEntity?.teamId, formData?.teamId]);

  const canShowOrganizationMenuItem = useMemo(
    () => Boolean(teamPublicPath) && (isEmployee || isSuperModer || isTeamOwner),
    [teamPublicPath, isEmployee, isSuperModer, isTeamOwner],
  );

  const teamOrganizationName = useMemo(
    () => (teamEntity ? Lang(teamEntity.name, language) : ""),
    [teamEntity, language],
  );

  const handleOrganizationClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      history.push(teamPublicPath);
    },
    [history, teamPublicPath],
  );

  const handleEditFormClick = useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (!formData?.teamId) {
        return;
      }
      history.push(`/team-edit/${formData.teamId}?formId=${formId}`);
    },
    [formData?.teamId, formId, history],
  );

  useEffect(() => {
    const teamId = formData?.teamId;
    if (!teamId) {
      setTeamEntity(null);
      return;
    }

    let cancelled = false;

    TeamAPI.Get({ idTeam: teamId })
      .then((r) => r.json() as Promise<Team<'Global'>>)
      .then((value) => {
        if (!cancelled && value?.teamId) {
          setTeamEntity(value);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setTeamEntity(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [formData?.teamId]);

   useEffect(() => {
    if (skipFetch) {
      if (formDataFromProps) {
        setFormData(formDataFromProps);
      }
      setLoading(false);
      return;
    }

    if (!formId) {
      return;
    }

    let cancelled = false;

    const fetchForm = async () => {
      try {
        setLoading(true);
        const response = await urlApi().getForm(formId);
        const form = await response.json();

        if (cancelled) {
          return;
        }

        setFormData(form);
      } catch (err) {
        if (!cancelled) {
          setError('Failed to fetch form data');
          console.error('Error fetching form:', err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchForm();

    return () => {
      cancelled = true;
    };
  }, [formId, skipFetch, formDataFromProps?.formId]);
  const translatedForm: FormData = API.toLang(formData, i18n.language)

  const visiblePpdCheckMarks = useMemo<PpdCheckMark[]>(() => {
    if (!Array.isArray(formData?.ppdWithCheckMark)) {
      return [];
    }

    return formData.ppdWithCheckMark
      .map((langGroup: any[], index: number) => ({
        index,
        name: langGroup?.find((item: any) => item.lang === language)?.name,
      }))
      .filter((item: { name?: string }) => !!item.name);
  }, [formData?.ppdWithCheckMark, language]);

  const isCheckMarkOnLeft =
    (formData?.ppdCheckMarkPosition ?? DEFAULT_CHECK_MARK_POSITION) === FormCheckMarkPosition.Left;

  useEffect(() => {
    if (!Array.isArray(formData?.ppdWithCheckMark)) {
      return;
    }

    const defaultState = formData?.ppdCheckMarkDefaultState ?? DEFAULT_CHECK_MARK_STATE;
    setPpdAcceptedStates(new Array(formData.ppdWithCheckMark.length).fill(defaultState));
  }, [formData?.ppdWithCheckMark, formData?.ppdCheckMarkDefaultState]);

  useEffect(() => {
    if (visiblePpdCheckMarks.length > 0) {
      const allAccepted = visiblePpdCheckMarks.every(({ index }) => ppdAcceptedStates[index]);
      setIsPpdAccepted(allAccepted);
    }
  }, [visiblePpdCheckMarks, ppdAcceptedStates, setIsPpdAccepted]);
  
  const handlePpdChange = (index: number, checked: boolean) => {
    setPpdAcceptedStates(prev => {
      const newStates = [...prev];
      newStates[index] = checked;
      return newStates;
    });
  };
  
  const ppdWithCheckMarks = visiblePpdCheckMarks.map(({ index, name }) => {
    const ppdParts = name.split(urlRegex);

    const ppdText = (
      <ProjectEditPageGridLabel fullWidth heightAuto>
        <div style={{ whiteSpace: 'pre-wrap', width: '100%', wordBreak: 'break-word' }}>
          {ppdParts.map((part, i) =>
            urlRegex.test(part) ? (
              <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                {part}
              </a>
            ) : (
              part
            )
          )}
        </div>
      </ProjectEditPageGridLabel>
    );

    const ppdCheckMark = (
      <FlexBox direction="row" directionMobile="row">
        <CommonInput
          type={INPUT_TYPES.checkbox} 
          title={''}
          checked={ppdAcceptedStates[index] || false}
          onChange={(ev: any) => handlePpdChange(index, ev.target.checked)}
        />
      </FlexBox>
    );

    return (
      <FlexBox key={index} align="flex-start" gx={isCheckMarkOnLeft ? 8 : undefined}>
        {isCheckMarkOnLeft ? ppdCheckMark : ppdText}
        {isCheckMarkOnLeft ? ppdText : ppdCheckMark}
      </FlexBox>
    );
  });
   
  const getTranslatedVariants = (variants: any[]) => {
    if (!variants || !Array.isArray(variants)) return [];

    return variants?.reduce((acc, val) => {
      const variant = val.find((v: any) => v.lang === i18n.language) || val[0];
      const isPhone = ['телефон', 'phone']?.includes(variant?.name?.toLowerCase())
      if (variant?.name === '') {
        return acc
      }
      if (!isRuPhoneCode && isPhone) {
        return acc
      }

      return [
        ...acc,
        {
          value: variant.name,
          label: variant.name
        }
      ]
    }, [])
  };

  const renderField = (field: any, index: number) => {
    const commonProps = {
      key: index,
      name: `field_${field.type}_${index}`,
      label: field.header,
      placeholder: field.placeholder,
      required: field.isRequired,
    };

    switch (field.type) {
      case 0: // Текстовое поле
        return (
           <Field
            {...commonProps}
            label={field.header || 'Текст'}
            component={TextInput}
          />
        );
      case 1: // Комментарий
        return (
           <Field
            {...commonProps}
            label={field.header || 'Комментарий'}
            component={TextInput}
            multiline={true}
          />
        );
      case 2: // Почта
        return (
           <Field
            {...commonProps}
            label={field.header || 'Почта'}
            component={TextInput}
          />
        );
      case 3: // Телефон
        return (
           <Field
            {...commonProps}
            label={field.header || 'Телефон'}
            component={PhoneInput}
          />
        );
      case 4: // Выпадающий список (одиночный выбор)
        return (
          <Field
            {...commonProps}
            label={field.header || 'Выбор'}
            component={DropdownField}
            options={getTranslatedVariants(field.inlineVariants)}
          />
        );
      case 6: // Текстовое поле (ФИО)
        return (
          <Field
            {...commonProps}
            label={field.header || 'Имя'}
            component={TextInput}
          />
        );
      case 7: // Текстовое поле (Фамилия)
        return (
          <Field
            {...commonProps}
             label={field.header || 'Фамилия'}
            component={TextInput}
          />
        );
      
      case 8: // Множественный выбор (чекбоксы)
        return (
          <Field
            {...commonProps}
            component={DropdownField}
            label={field.header || 'Множественный выбор'}
            options={getTranslatedVariants(field.inlineVariants)}
            isMulti={true}
          />
        );
      case 9: // Telegram
        return (
          <Field
            {...commonProps}
            label={field.header || 'Telegram'}
            component={TextInput}
          />
        );
      case 10: // Доп. почта
        return (
           <Field
            {...commonProps}
            label={field.header || 'Почта'}
            component={TextInput}
          />
        );
      default:
        return null;
    }
  };

  const statusTagsField = useMemo(() => {
    if (!statusTags || statusTags?.length < 2) {
      return null;
    }
    return (
      <CommonInput 
        type={INPUT_TYPES.dropdown}
        label="Профиль"
        required={true}
        value={(statusTags?.find((status) => status?.formId === formId)?.name as unknown as string) || ''} 
        options={statusTags.map((status) => ({
          value: status.formId,
          label: Lang(status.name, i18n.language),
        }))}
        onChange={({ value }: { value: string }) => {
          setSelectedFormId(value);
        }}
      />
    )
  }, [statusTags, formId, i18n.language])

const handleCloseClick = () => {
  if (window.history.length > 1 && document.referrer !== '') {
    window.history.back();
  } else {
    window.location.href = '/';
  }
};
  

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!translatedForm) return null;
  
  if (!answersCount && translatedForm?.registrationRequestLimit) {
    return (
      <CoreContainer>
      <Wrapper>
        <MainTitle>{translatedForm.header}</MainTitle>
        <MainDescription>{translatedForm.description}</MainDescription>
        <FlexBox direction="column" offsetTop={32} gy={16} justify="center" align="center">
        <СompletedTitle>{t('form_page.deadline')}</СompletedTitle>
        <SendButton onClick={handleCloseClick} >
              {t('form_page.close')}
        </SendButton>
        </FlexBox>
      </Wrapper>
    </CoreContainer>
    )
  };

  const formContent = (
    <Wrapper style={isModal ? { margin: 0, maxWidth: '100%' } : undefined}>
      {translatedForm?.titleImages && Array.isArray(translatedForm.titleImages) && translatedForm.titleImages.length > 0 && (
        <TitleImagesContainer>
          <ResizedImageEnhanced
            files={translatedForm.titleImages}
            showDefaultPlaceholder={false}
            showEmptyPlaceholder={false}
          />
        </TitleImagesContainer>
      )}
      <TitleWrapper>
        <MainTitle>{translatedForm.header}</MainTitle>
        {canShowTeamFormMenu && (isToolbarHovered || isMdUp) && (
          <SettingsDotsWrapper>
            <Dropdown
              offsetY={8}
              offsetX={0}
              hideArrow
              orientation="right"
              target={<SettingsDotsIcon />}
            >
              {canShowOrganizationMenuItem && (
                <DropdownListItemTeamEdit
                  theming={theme.navigationBar.login}
                  onClick={handleOrganizationClick}
                >
                  {t("form_page.organization_with_name", { name: teamOrganizationName })}
                </DropdownListItemTeamEdit>
              )}
              {canEditTeamFeedbackForm && (
                <DropdownListItemTeamEdit
                  theming={theme.navigationBar.login}
                  onClick={handleEditFormClick}
                >
                  {t("form_page.edit_form")}
                </DropdownListItemTeamEdit>
              )}
            </Dropdown>
          </SettingsDotsWrapper>
        )}
      </TitleWrapper>
      <MainDescription>{translatedForm.description}</MainDescription>
      {translatedForm?.isRegistrationRequestLimitVisible && <AnswersCount>{t('form_page.count_text')} <span>{answersCount}</span></AnswersCount>}
      <FlexBox direction="column" gy={16} gyMobile={16} offsetTop={48}>
        {statusTagsField}
        {translatedForm.formFields?.map((field: any, index: number) =>
          renderField(field, index)
        )}

        <Divider/>
        <FlexBox gx={24} directionMobile={'column'} gyMobile={16} gxMobile={'0px'} align="center">
          {onCancel && (
            <BrgButton variant={ButtonVariant.Hollow} onClick={onCancel}>
              {cancelText || t('close')}
            </BrgButton>
          )}
          <SendButton $mobileFullWidth onClick={handleSubmit} disabled={!isPpdAccepted || pristine || invalid || submitting || isSubmiting}>
            {translatedForm.textSubmitButton}
          </SendButton>
          {parts?.length > 0 && (
            <div style={{fontSize: '13px', color: '#909090'}}> {parts.map((part, i) =>
              urlRegex.test(part) ? (
                <a key={i} href={part} target="_blank" rel="noopener noreferrer">
                  {part}
                </a>
              ) : (
                part
              )
            )}
          </div>
          )}
        </FlexBox>
      </FlexBox>
      <FlexBox direction="column" gy={8} offsetTop={16}>
          {ppdWithCheckMarks}
      </FlexBox>
    </Wrapper>
  );

  if (isModal) {
    return formContent;
  }

  return (
    <>
      <CoreContainer>
          <TeamFormAdminLinksWrap
            onMouseEnter={() => setIsToolbarHovered(true)}
            onMouseLeave={() => setIsToolbarHovered(false)}
          >
            <FlexBox align="center" style={{ position: "relative", minHeight: 28 }}>
            {formContent}
          </FlexBox>
      </TeamFormAdminLinksWrap>
      </CoreContainer>
    </>
  );
}
const validate = (values: any, props: any) => {
  const {data} = props
  const errors: any = {};
   
 data.formFields.forEach((field: any, index: number) => {
    const fieldName = `field_${field.type}_${index}`;
    
    if (field.isRequired && !values[fieldName]) {
      errors[fieldName] = 'Обязательное поле';
    }

    // Дополнительная валидация для email
    if (field.type === 2 && values[fieldName] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values[fieldName])) {
      errors[fieldName] = 'Некорректный email';
    }

    // Валидация для телефона
    if (field.type === 3 && values[fieldName]) {
      const phoneValue = values[fieldName];
      const digitsOnly = phoneValue.replace(/\D/g, '');
      if (digitsOnly.length < 11) {
        errors[fieldName] = 'Некорректный номер телефона';
      }
    }
  });

  
  return errors;
};

export const EventRegistrationForm = reduxForm({
  form: FORM_NAME,
  validate: validate,
  
})(EventRegistrationComponent);
